module.exports = __webpack_public_path__ + "img/case_3.1deda2cc.png";